module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/order_status-69ac85392e40e8904ab1f2229e836057.png";